import React from 'react'
import Collection from '../common/collection'

function CollectionS({ props }) {
  return (
    <Collection
      alt="Bichos"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/18.+bichos1.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/18.+bichos11.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/18.+bichos3.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/18.+bichos47.jpg',
      ]}
    />
  )
}


export default CollectionS
